import { EntityState } from '@reduxjs/toolkit';
import { CoverageAdapter, CoverageState } from '@store/coverage/coverage.slice';

export const CoverageSelector = CoverageAdapter.getSelectors(
  (state) => state as EntityState<CoverageState>,
);
